import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hunch3tcw6: FaireBrandEntity = {
  token: "b_hunch3tcw6",
  type: "brand",
  name: "FD Market",
  avatarUrl:
    "https://cdn.faire.com/fastly/060d96fe99e82696532392f72019426c764802f78cea57bfba50343f8cc9c386.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/701664490f0111390f121c95e0ca12d3b84a0901af17ae420e38cc76c0f4f1ce.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/060d96fe99e82696532392f72019426c764802f78cea57bfba50343f8cc9c386.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/701664490f0111390f121c95e0ca12d3b84a0901af17ae420e38cc76c0f4f1ce.jpeg",
  location: "Emmaus, PA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 111,
  isTopShop: true,
  isInsider: true,
  description:
    "FD Market is a consciously curated sustainable goods and refill shop! Our mission is to help you reduce waste and create a beautiful space. Our less-waste, more mindful goods are the perfect addition to the clean and green home. Our thoughtful approach to ingredient sourcing and quality, as well as packaging helps to reduce the unnecessary amount of waste that comes with traditional retail business. \n****HOLIDAY 2025: We are currently running on a 14 business day lead time. Our products are handmade. Please reach out at the time of your order if you need expedited shipping. We are a very small business handmaking our products with love and care. We appreciate your patience during this busy season. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:35.981Z",
    importedBy: "entity-db-cli",
  },
};
